import React, { useEffect, useState } from 'react'

import AutoSelectAsyncList from '@pixel/core/AutoSelectAsyncList'
import useUserEmailTemplates, { UserEmailTemplate } from '../hooks/useUserEmailTemplates'
import { useLocalizedText } from '../contexts/Localization/localizationHooks'
import { LocalizedText } from '../contexts/Localization/LocalizationTypes'

interface UserEmailTemplatesInputProps {
    value: UserEmailTemplate
    onChange: (event: any, newValue: UserEmailTemplate) => void
}
export default function UserEmailTemplatesInput({
    value,
    onChange,
}: UserEmailTemplatesInputProps) {
    const TEMPLATE = useLocalizedText(LocalizedText.CommonTemplate)

    const [textInput, setTextInput] = useState('')
    const [page, setPage] = useState(0)
    const [options, setOptions] = useState<Array<UserEmailTemplate>>([])

    const {
        data,
        loading,
    } = useUserEmailTemplates({
        page,
        keywords: textInput,
        onNewResults: (response) => {
            setOptions(response.userEmailTemplates)
        },
        onNextPageResults: (response) => {
            setOptions(currentOptions => [...currentOptions, ...response.userEmailTemplates])
        }
    })

    return (
        <AutoSelectAsyncList 
            fieldLabel={TEMPLATE}
            paginated
            debounceInput={2500}
            loading={loading}
            loadingNextPage={loading}
            noResults={options.length === 0}
            options={options}
            value={value}
            inputValue={textInput}
            onDebouncedKeyStroke={(newInput: string) => {
                setPage(0)
                setTextInput(newInput)
            }}
            onChange={(event: any, newValue: UserEmailTemplate) => {
                if (typeof onChange === 'function') {
                    onChange(event, newValue)
                }
                if (newValue) {
                    setTextInput(newValue.name)
                } else {
                    setTextInput('')
                }
            }}
            onClose={() => {
                if (value) {
                    setTextInput(value.name)
                }
            }}
            onFetchNextPage={() => setPage(current => current + 1)}
            currentPage={page}
            filterOptions={(x: UserEmailTemplate) => x}
            disableCloseOnSelect={false}

            getOptionLabel={(option: UserEmailTemplate) => option.name}
            getValueLabel={(option: UserEmailTemplate) => option.name}
            isOptionEqualToValue={(option: UserEmailTemplate, value: UserEmailTemplate) => option.SId === value.SId}
        />
    )
}
